import React, { useState } from 'react';
import { InstagramIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
export function EditorialContact() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    if (!data.get('Nombre completo') || !data.get('Correo electrónico') || !data.get('Mensaje')) {
      setError('Completá nombre, email y mensaje para enviarnos tu consulta.');
      return;
    }
    setError('');
    try {
      await fetch('https://formsubmit.co/ajax/info@estudiovcuy.com', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: data
      });
    } catch {
      // El envío puede completarse aunque la respuesta no sea legible desde el navegador.
    }
    setSent(true);
    form.reset();
  };
  return <>
      <section id="contacto" className="grid lg:grid-cols-2" data-id="element-64" data-mp="1ut06voupa89i">
        <div className="bg-[#1A1A1A] px-7 py-20 text-white md:px-16 lg:px-24" data-id="element-65" data-mp="1uvmf7qpf0rss">
          <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#d88b67]" data-id="element-66" data-mp="1pw01lg5od9jg">
            Contacto
          </p>
          <h2 className="font-editorial mt-5 max-w-md text-5xl leading-tight" data-id="element-67" data-mp="24pczskif8i37">
            ¿Tenés un proyecto en mente?
          </h2>
          <p className="mt-6 max-w-sm text-sm leading-7 text-white/65" data-id="element-68" data-mp="2drvxyrb9i6j4">
            Contame tu idea. La primera consulta es sin cargo.
          </p>
          <div className="mt-12 space-y-5 text-sm text-white/80" data-id="element-69" data-mp="28t19p9uizprm">
            <p className="flex gap-3" data-id="element-70" data-mp="2nh5tyi9889ci">
              <MailIcon size={18} className="text-[#C4724A]" data-id="element-71" data-mp="2nka2frtq5r8z" />
              info@estudiovcuy.com
            </p>
            <p className="flex gap-3" data-id="element-72" data-mp="2wivjfijjsy7n">
              <PhoneIcon size={18} className="text-[#C4724A]" data-id="element-73" data-mp="2wjx7cnlnxf6s" />
              +598 95 285 003
            </p>
            <a href="https://www.instagram.com/vcestudiouy/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noreferrer" className="flex w-fit gap-3 transition-colors hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#d88b67]" data-id="element-74" data-mp="2sile883kybtu">
              <InstagramIcon size={18} className="text-[#C4724A]" data-id="element-75" data-mp="3e9wkef8nftru" />
              @vcestudiouy
            </a>
            <p className="flex gap-3" data-id="element-76" data-mp="3ibrlbimo4553">
              <MapPinIcon size={18} className="text-[#C4724A]" data-id="element-77" data-mp="3iaq2ut3bogdc" />
              Montevideo, Uruguay
            </p>
          </div>
        </div>
        <div className="bg-[#F7F4EF] px-7 py-20 md:px-16 lg:px-24" data-id="element-78" data-mp="3s8mgbrjqfnem">
          <h2 className="font-editorial text-3xl" data-id="element-79" data-mp="3s7bcxsu78ho1">Hablemos de tu idea</h2>
          {sent && <p role="status" className="mt-5 bg-[#e5eee2] p-4 text-sm text-[#405238]" data-id="element-80" data-mp="10icir78cmkk">
              Gracias por escribir. Te responderemos a la brevedad.
            </p>}
          {error && <p role="alert" className="mt-5 text-sm text-[#a34d31]" data-id="element-81" data-mp="jzd79m1bvc6y">
              {error}
            </p>}
          <form noValidate onSubmit={submit} className="mt-6 grid gap-5" data-id="element-82" data-mp="f7ld71iyqoc2">
            <input type="hidden" name="_subject" value="Nueva consulta desde VC Estudio" data-id="element-83" data-mp="b6047r9juu75" />
            <label className="text-xs font-bold" data-id="element-84" data-mp="688b4tx6521d">
              Nombre completo
              <input name="Nombre completo" className="input-field" data-id="element-85" data-mp="12xz3amhzmd40" />
            </label>
            <label className="text-xs font-bold" data-id="element-86" data-mp="12vmqenr36sxt">
              Email
              <input name="Correo electrónico" type="email" className="input-field" data-id="element-87" data-mp="ywvu2iug3fbr" />
            </label>
            <label className="text-xs font-bold" data-id="element-88" data-mp="tvg6ok4sowq7">
              Teléfono <span className="font-normal" data-id="element-89" data-mp="oyzglke1c8ah">(opcional)</span>
              <input name="Teléfono" className="input-field" data-id="element-90" data-mp="p0kffm7dude5" />
            </label>
            <label className="text-xs font-bold" data-id="element-91" data-mp="3elf9kf6zgfly">
              Tipo de proyecto
              <select name="Tipo de proyecto" className="input-field" data-id="element-92" data-mp="39mua4hzk1zyk">
                <option data-id="element-93" data-mp="11fgyvfp35ihs">Vivienda</option>
                <option data-id="element-94" data-mp="11efm96sf8nxy">Reforma</option>
                <option data-id="element-95" data-mp="166z2ycmenz6z">Local</option>
                <option data-id="element-96" data-mp="1678rrwvps0b3">Interiores</option>
                <option data-id="element-97" data-mp="sf11mnyxr7ld">Otro</option>
              </select>
            </label>
            <label className="text-xs font-bold" data-id="element-98" data-mp="scy13a05pw2e">
              Mensaje
              <textarea name="Mensaje" rows={3} className="input-field resize-none" placeholder="Contame un poco sobre tu idea..." data-id="element-99" data-mp="xex60objp11g" />
            </label>
            <button className="mt-3 bg-[#C4724A] py-4 text-xs font-bold uppercase tracking-wider text-white hover:bg-[#a95d3b]" data-id="element-100" data-mp="1p378zin8se3c">
              Enviar consulta
            </button>
          </form>
        </div>
      </section>
      <footer className="bg-[#1A1A1A] px-5 py-12 text-white md:px-10" data-id="element-101" data-mp="3vw1335yc0k05">
        <div className="mx-auto flex max-w-[1440px] flex-col gap-8 md:flex-row md:items-center md:justify-between" data-id="element-102" data-mp="3vxucuu48rkcd">
          <div data-id="element-103" data-mp="3tbbgffc8u14i">
            <p className="font-editorial text-2xl" data-id="element-104" data-mp="3tatmwqgyu10a">VC Estudio</p>
            <p className="mt-2 text-xs text-white/50" data-id="element-105" data-mp="3tdfswlo7k8ge">
              Arquitectura que transforma formas de vivir.
            </p>
          </div>
          <nav className="flex gap-5 text-xs text-white/70" data-id="element-106" data-mp="66vkyzw75zwr">
            <a href="#inicio" data-id="element-107" data-mp="649dt1d7xmf2">Inicio</a>
            <a href="#proyectos" data-id="element-108" data-mp="17ameqkxvtkk">Proyectos</a>
            <a href="#contacto" data-id="element-109" data-mp="15fxz2agljbq">Contacto</a>
          </nav>
          <a href="https://www.instagram.com/vcestudiouy/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noreferrer" aria-label="Instagram de VC Estudio" className="w-fit transition-transform duration-200 hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#d88b67]" data-id="element-110" data-mp="39odqv1seswuj">
            <svg aria-hidden="true" viewBox="0 0 24 24" className="h-9 w-9" fill="none" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round" data-id="element-111" data-mp="2qv9v9avms9xa">
              <defs data-id="element-112" data-mp="ut6evzpjeg4z">
                <linearGradient id="instagram-brand" x1="0" y1="24" x2="24" y2="0" data-id="element-113" data-mp="usoeqrzr7hrs">
                  <stop offset="0%" stopColor="#F58529" data-id="element-114" data-mp="14ihmfhwrzcqr" />
                  <stop offset="35%" stopColor="#DD2A7B" data-id="element-115" data-mp="6vr0otinb01f" />
                  <stop offset="70%" stopColor="#8134AF" data-id="element-116" data-mp="6xbvmk8vgkzt" />
                  <stop offset="100%" stopColor="#515BD4" data-id="element-117" data-mp="buc1au1t7lqe" />
                </linearGradient>
              </defs>
              <g stroke="url(#instagram-brand)" data-id="element-118" data-mp="gtoya7mea96p">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-119" data-mp="gw1h0mzz8nkt" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z" data-id="element-120" data-mp="kwbne0rolg07" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-121" data-mp="1s9vf5oyu9ac9" />
              </g>
            </svg>
          </a>
        </div>
      </footer>
    </>;
}